import { combineReducers } from 'redux';

import cameraReducer from './camera';
import themeReducer from './theme';
import contentReducer from './content';
import envReducer from './env';
import cursorReducer from './cursor';
import toolReducer from './tool';


const rootReducer = combineReducers({
    camera: cameraReducer,
    theme: themeReducer,
    content: contentReducer,
    env: envReducer,
    cursor: cursorReducer,
    tool: toolReducer,
});

export default rootReducer;